import React, { useEffect, useMemo, useState } from 'react';
import { Row, Col, FormGroup } from 'react-bootstrap';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Popover from 'react-bootstrap/Popover';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { MultiSelect } from 'react-multi-select-component';
import { isEmpty, set } from 'lodash';
import { useTranslation } from 'react-i18next';
import { Page_Size, checkArray, createOptions, fileTypeOptions } from '../../../../Components/helper';
import * as action from './store/DamFolder.action';

function DamFolderFilter() {
  const { t } = useTranslation('common');
  const dispatch = useDispatch();
  const { devOrderId } = useParams();
  const [isApply, setIsApply] = useState(false);
  const reducer = useSelector((reducerstate) => reducerstate);
  const {
    damProductFolderModule: {
      filterValues: { folder, fileType },
    },
    damProductFileModule: { folderOptions },
  } = reducer;

  const folderOptionsList = useMemo(() => {
    if (checkArray(folderOptions)) return createOptions(folderOptions, 'name', '_id');
    return [];
  }, [folderOptions]);

  const handleInputChange = async (value, name) => {
    const obj = {};
    set(obj, `${name}`, value);
    await dispatch(action.filterDamFolderSortData(obj));
  };

  const handleFilterApply = async () => {
    const obj = {
      pageIndex: 1,
      pageSize: Page_Size,
      folder,
      fileType,
    };

    let res = {};
    localStorage.setItem('damProductFolderListFilter', JSON.stringify(obj));
    setIsApply(true);

    if (devOrderId) {
      obj.devOrderId = devOrderId;
    }

    res = await dispatch(action.fetchDamProductFolders(obj));

    await dispatch(action.filterDamFolderSortData(obj));
    if (res) {
      const cloneObj = {
        loading: false,
      };
      await dispatch(action.filterDamFolderSortData(cloneObj));
    }
  };

  const handleFilterClear = async () => {
    setIsApply(false);
    const sortinObj = {
      pageIndex: 1,
      pageSize: Page_Size,
      folder: [],
      fileType: [],
    };

    await dispatch(action.filterDamFolderSortData(sortinObj));
    localStorage.removeItem('damProductFolderListFilter');

    let res = {};

    if (devOrderId) {
      sortinObj.devOrderId = devOrderId;
    }

    res = await dispatch(action.fetchDamProductFolders(sortinObj));

    if (res) {
      const obj = {
        loading: false,
      };
      await dispatch(action.filterDamFolderSortData(obj));
    }
  };

  useEffect(() => {
    const localstorageFilter = JSON.parse(localStorage.getItem('damProductFolderListFilter'));
    if (localstorageFilter) {
      for (const keys in localstorageFilter) {
        if (localstorageFilter[keys].length > 0) {
          setIsApply(true);
        }
      }
      dispatch(
        action.filterDamFolderSortData({
          pageIndex: localstorageFilter?.pageIndex,
          pageSize: localstorageFilter?.pageSize,
          loading: localstorageFilter?.loading,
          folder: localstorageFilter?.folder,
          fileType: localstorageFilter?.fileType,
        }),
      );
    }
  }, []);

  return (
    <button type="button" title="Sort" className={isApply ? 'filter-btn filter-button_delete active' : 'filter-btn filter-button_delete'}>
      <OverlayTrigger
        placement="bottom"
        trigger="click"
        rootClose
        overlay={
          <Popover className="custom-popover popover-filter">
            <Popover.Content>
              <Row className="form-row">
                <Col md={6}>
                  <FormGroup>
                    <label className="select-label">{t('DAM_MAIN_VIEW.LISTING_VIEW.FILE_Type')}</label>
                    <MultiSelect
                      name="group"
                      options={fileTypeOptions}
                      className="custom-multiselect w-100"
                      labelledBy="Select file type"
                      onChange={(selected) =>
                        handleInputChange(
                          selected.map((val) => val.value),
                          'fileType',
                        )
                      }
                      value={fileTypeOptions.filter((val) => !isEmpty(fileType) && fileType.includes(val.value))}
                    />
                  </FormGroup>
                </Col>

                <Col md={6}>
                  <FormGroup>
                    <label className="select-label">Folder</label>
                    <MultiSelect
                      name="group"
                      options={folderOptionsList}
                      className="custom-multiselect w-100"
                      labelledBy="Select secondary colour"
                      onChange={(selected) =>
                        handleInputChange(
                          selected.map((val) => val._id),
                          'folder',
                        )
                      }
                      value={folderOptionsList.filter((val) => !isEmpty(folder) && folder.includes(val._id))}
                    />
                  </FormGroup>
                </Col>
              </Row>

              <Row>
                <Col md={12}>
                  <div className="d-flex justify-content-end">
                    <button onClick={() => handleFilterApply()} className="btn btn-default mr-2" type="button">
                      {t('DAM_MAIN_VIEW.LISTING_VIEW.APPLY')}
                    </button>
                    <button onClick={() => handleFilterClear()} className="btn btn-default" type="button">
                      {t('DAM_MAIN_VIEW.LISTING_VIEW.CLEAR')}
                    </button>
                  </div>
                </Col>
              </Row>
            </Popover.Content>
          </Popover>
        }
      >
        <i className="icon-filter" />
      </OverlayTrigger>
    </button>
  );
}

export default DamFolderFilter;
